/**
 * Created by luishenriques on 11/08/2017.
 */
import io from 'socket.io-client';

export default (function () {
  const socketClient = {};
  let socket;
  let userId;
  let organizationId;
  let tenantId;
  const listeners = {};

  socketClient.init = function (url, user, organization, tenant) {
    console.log('### Socket.io | Init connection....');
    userId = user;
    organizationId = organization._id;
    tenantId = tenant;

    socket = io(url, {
      path: '/socket-v4',
      transports: ['websocket'], // Prefer WebSocket transport
    });

    socket.on('connect', () => {
      socketClient.joinUser();
      console.log('### Socket.io | Connection ok');
      socketClient.emit('connect', {}, userId);
    });

    socket.on('connect_error', data => {
      console.log('### Socket.io ERROR', data);
      console.error('### Socket.io Connection error', data);
      socketClient.emit('connect_error', data, userId);
    });

    socket.on('CHAT_MESSAGE', result => {
      if (result.operation === 'CREATED') {
        socketClient.emit('CHAT_MESSAGE', result.data, userId);
      }
    });

    socket.on('BADGE', result => {
      if (result.operation === 'UPDATED') {
        socketClient.emit('BADGE', result.data, userId);
      }
    });

    socket.on('CHAT_GROUP', socketClient.onChatGroupChange);

    socket.on('CHAT_VIDEO_READY', result => {
      if (result.operation === 'UPDATED') {
        socketClient.emit('CHAT_VIDEO_READY', result.data, userId);
      }
    });

    socket.on('COURSE_SCORM', result => {
      socketClient.emit('COURSE_SCORM', result.data, userId);
    });

    socket.on('COURSE_SCORM_PREVIEW', result => {
      socketClient.emit('COURSE_SCORM_PREVIEW', result.data, userId);
    });
  };

  socketClient.joinUser = function () {
    socket.emit(
      'USER ONLINE',
      {
        tenant: tenantId,
        organization: organizationId,
        user: userId,
        browser: `${navigator.userAgent}/${navigator.platform}/${navigator.appName}/${navigator.appVersion}`,
        language: navigator.language || navigator.userLanguage,
      },
      () => null,
    );
  };

  socketClient.joinChatGroup = function (chatGroupId) {
    socket.emit('CHAT_GROUP JOIN', { group: chatGroupId });
  };

  socketClient.leaveChatGroup = function (chatGroupId) {
    socket.emit('CHAT_GROUP LEAVE', { group: chatGroupId });
  };

  socketClient.sendMessage = function (chatGroupId, message, callback) {
    socket.emit(
      'CHAT_MESSAGE TEXT',
      {
        organization: organizationId,
        group: chatGroupId,
        type: 'message',
        text: message,
      },
      callback,
    );
  };

  socketClient.sendFile = function (chatGroupId, type, data, callback) {
    socket.emit(
      'CHAT_MESSAGE TEXT',
      {
        organization: organizationId,
        group: chatGroupId,
        type,
        ...data,
      },
      callback,
    );
  };

  socketClient.setMessageRead = function (messageId, callback) {
    socket.emit(
      'CHAT_MESSAGE READ',
      {
        organization: organizationId,
        message: messageId,
      },
      callback,
    );
  };

  socketClient.onChatGroupChange = function (result) {
    if (result.operation === 'UPDATED') {
      const chatGroup = result.data;
      const { unreadMessages } = chatGroup;
      if (unreadMessages > 0) {
        $(`#${chatGroup._id}`)
          .find('.m-widget4__ext')
          .html(
            `<span id="unreadMessages" class="m-badge m-badge--success">${unreadMessages}</span>`,
          );
      } else {
        $(`#${chatGroup._id}`).find('.m-widget4__ext').html('');
      }
    }
  };

  // Event dispatcher functionality, to avoid circular dependencies
  // with other modules, such as ChatService, ScoreValidation, etc
  socketClient.addEventListener = function (type, callback) {
    if (!listeners[type]) listeners[type] = [];
    listeners[type].push(callback);
  };

  socketClient.removeEventListener = function (type, callback) {
    if (listeners[type]) {
      for (let i = listeners[type].length - 1; i >= 0; i -= 1) {
        if (listeners[type][i] === callback) {
          listeners[type].splice(i, 1);
        }
      }
    }
  };

  socketClient.dispatchEvent = function (type, ...args) {
    if (listeners[type]) {
      for (let i = 0; i < listeners[type].length; i += 1) {
        if (listeners[type][i]) {
          listeners[type][i](...args);
        }
      }
    }
  };

  socketClient.on = socketClient.addEventListener;
  socketClient.off = socketClient.removeEventListener;
  socketClient.removeListener = socketClient.removeEventListener;
  socketClient.emit = socketClient.dispatchEvent;

  return socketClient;
})();
